// const chefsImageSwiper = new Swiper('.custom-background-section .swiper', {
  //   slidesPerView: "auto",
  //   spaceBetween: 20,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     type: "progressbar",
  //   },
  //   watchOverflow: true,
  // });
  // const chefsSwiperCustomBtnPrev = document.querySelector('.custom-background-section .custom-swiper-button-prev');
  // const chefsSwiperCustomBtnNext = document.querySelector('.custom-background-section .custom-swiper-button-next');
  // chefsSwiperCustomBtnPrev?.addEventListener('click', () => chefsImageSwiper?.slidePrev());
  // chefsSwiperCustomBtnNext?.addEventListener('click', () => chefsImageSwiper?.slideNext());

  // chefsImageSwiper.on('realIndexChange', (e) => {
  //   chefsSwiperCustomBtnPrev.disabled = e.isBeginning;
  //   chefsSwiperCustomBtnNext.disabled = e.isEnd;
  // })

const chefsImageSwiper = new Swiper(".chef-with-background .swiper", {
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 25,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
});